<template>
    <core-basic-drop-down
        style="height: 34px"
        v-if="genders.length"
        :items="genders"
        :selection.sync="selected"
        forceFirstOption
        :translateLabels=true
        :noneLabel="$t('general.gender.default')"
    ></core-basic-drop-down>
</template>

<script>
export default {
  data () {
    return {
      genders: this.$store.getters.genders,
      selected: this.selectedValue
    }
  },
  props: {
    selectedValue: {
      default: null,
      type: String | Number,
      required: false
    }
  },
  watch: {
    selected (val) {
      this.$emit('update:selectedValue', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Gender.vue